import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
import store from './store'
import htmlToPdf from './utils/htmlToPdf';

// import htmlToPdf2 from './utils/htmlToPdf2';
import '@/assets/fonts/font.scss'
Vue.prototype.$echarts = echarts
Vue.use(htmlToPdf);
// Vue.use(htmlToPdf2);

Vue.config.productionTip = false
Vue.use(ElementUI) 
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
